// Module
var code = "<abx-type-ahead abx-value=\"vm.value\" abx-loading=\"vm.loading\" abx-options=\"vm.suggestions\" abx-on-select=\"vm.onSelect({ $event: $event })\" abx-on-change=\"vm.onChange({ $event : $event })\" abx-on-focus=\"vm.handleFocus()\" abx-on-blur=\"vm.onBlur()\" abx-disabled=\"vm.disabled\"></abx-type-ahead> ";
// Exports
module.exports = code;